import styled from 'styled-components';

const ScreenContainer = styled.div`
    padding: 1rem;

    @media (max-width: 991px) {
        padding: 0.5rem;
    }
`;

export default ScreenContainer;
